// Navbar Menu
export const HOME_PAGE = 'home_page'
export const MENU_DASHBOARD = 'menu-dashboard'
export const MENU_ORDER_ACTIVITY = 'menu-order_activity'
export const MENU_APPOINTMENT = 'menu-appointment'
export const MENU_BILLING = 'menu-billing'
export const MENU_BILLING_INVOICES = 'menu-billing_invoices'
export const MENU_BILLING_CLIENT_PRICING = 'menu-billing_client_pricing'
export const MENU_TAXES = 'menu-taxes'
export const MENU_TAX_RATES = 'menu-tax_rates'
export const MENU_TAX_CLASSES = 'menu-tax_classes'
export const MENU_RETURN = 'menu-return'
export const MENU_PACKING = 'menu-packing'
export const MENU_SERIAL_NUMBER = 'menu-serial_number'
export const MENU_SHIPPING = 'menu-shipping'
export const MENU_ORDERS = 'menu-orders'
export const MENU_RECEIVING = 'menu-receiving'
export const MENU_RECEIVING_MOBILE = 'menu-receiving_mobile'
export const MENU_TODO = 'menu-todo'
export const MENU_PURCHASE_ORDER = 'menu-purchase_order'
export const MENU_JOBS = 'menu-jobs'
export const MENU_INVENTORY = 'menu-inventory'
export const MENU_INVENTORY_COUNTS = 'menu-inventory_counts'
export const MENU_TRANSACTIONS = 'menu-transactions'
export const MENU_RECEIVING_TRANSACTIONS = 'menu-receiving_transactions'
export const MENU_ZONES = 'menu-zones'
export const MENU_ITEM = 'menu-item'
export const MENU_BARCODE_GENERATOR = 'menu-barcode_generator'
export const MENU_CLIENTS = 'menu-clients'
export const MENU_CLIENT = 'menu-client'
export const MENU_SUPPLIER = 'menu-supplier'
export const MENU_SUPPLY = 'menu-supply'
export const MENU_WAREHOUSE = 'menu-warehouse'
export const MENU_LOCATION = 'menu-location'
export const MENU_SECURITY = 'menu-security'
export const MENU_PERMISSIONS = 'menu-permissions'
export const MENU_ROLES = 'menu-roles'
export const MENU_USER = 'menu-user'
export const MENU_SYSTEM = 'menu-system'
export const MENU_PLATFORMS = 'menu-platforms'
export const MENU_COUNTRY = 'menu-country'
export const MENU_LANGUAGES = 'menu-languages'
export const MENU_HOLIDAY = 'menu-holiday'
export const MENU_ERRORS = 'menu-errors'
export const MENU_DEPARTMENTS = 'menu-departments'
export const MENU_PROVINCE = 'menu-province'
export const MENU_CARRIER = 'menu-carrier'
export const MENU_SETTINGS = 'menu-settings'
export const MENU_PROFILE = 'menu-profile'
export const MENU_ADMIN = 'menu-admin'
export const MENU_PRODUCTS = 'menu-products'
export const MENU_OPERATIONAL_FUNCTIONS = 'menu-operational_functions'
export const MENU_MOBILE_LAYOUT = 'menu-mobile_layout'
export const MENU_MOBILE_INVENTORY = 'menu-mobile_inventory'
export const MENU_MOBILE_ITEMS = 'menu-mobile_items'
export const MENU_MOBILE_RECEIVING = 'menu-mobile_receiving'
export const MENU_MOBILE_TODO = 'menu-mobile_todo'
export const MENU_LOGS = 'menu-logs'
export const MENU_SUPPORT = 'menu-support'
export const MENU_INTERNAL_SUPPORT = 'menu-internal_support'
export const MENU_REPORTS = 'menu-reports'
export const MENU_ISSUES = 'menu-issues'

// Permissions
export const DEVELOPMENT = 'development'
export const LOGS_VIEW = 'logs-view'
export const APPOINTMENT_CREATE = 'appointment-create'
export const APPOINTMENT_EDIT = 'appointment-edit'
export const APPOINTMENT_DELETE = 'appointment-delete'
export const APPOINTMENT_CANCEL = 'appointment-cancel'
export const APPOINTMENT_CHANGE_STATUS = 'appointment-change_status'
export const BILLING_CREATE = 'billing-create'
export const BILLING_EDIT = 'billing-edit'
export const BILLING_DELETE = 'billing-delete'
export const INVOICE_DETAILS = 'invoice-details'
export const INVOICE_EDIT = 'invoice-edit'
export const CLIENT_CREATE = 'client-create'
export const CLIENT_EDIT = 'client-edit'
export const CLIENT_DELETE = 'client-delete'
export const INVENTORY_TRANSFER_SKU2SKU = 'inventory-transfer_sku_to_sku'
export const INVENTORY_TRANSFER_WHS2WHS = 'inventory-transfer_whs_to_whs'
export const INVENTORY_LOCATION_TRANSFER = 'inventory-location_transfer'
export const INVENTORY_TRANSFER = 'inventory-transfer'
export const INVENTORY_HOLD = 'inventory-hold'
export const INVENTORY_RELEASE = 'inventory-release'
export const INVENTORY_ADJUST = 'inventory-adjust'
export const INVENTORY_CREATE = 'inventory-create'
export const ITEM_CREATE = 'item-create'
export const ITEM_EDIT = 'item-edit'
export const ITEM_VIEW = 'item-view'
export const ITEM_EDIT_SKU = 'item-edit_sku'
export const ITEM_DELETE = 'item-delete'
export const ITEM_RESEND_TO_PROXPERT = 'item-resend_to_proxpert'
export const ITEM_KITTING = 'item-kitting'
export const ITEM_PRINT = 'item-print'
export const LOCATION_CREATE = 'location-create'
export const LOCATION_EDIT = 'location-edit'
export const LOCATION_DELETE = 'location-delete'
export const LOCATION_PRINT = 'location-print'
export const ORDERS_CHANGE_ORDER_STATUS = 'orders-change_order_status'
export const ORDERS_CREATE = 'orders-create'
export const ORDERS_INTEGRATION = 'orders-integration'
export const ORDERS_CANCEL = 'orders-cancel'
export const ORDERS_RELEASE = 'orders-release'
export const ORDERS_IMPORT = 'orders-import'
export const ORDERS_EXPORT = 'orders-export'
export const ORDERS_EDIT = 'orders-edit'
export const ORDERS_EDIT_AFTER_PROCESS = 'orders-edit_after_process'
export const ORDERS_EDIT_PACKED = 'orders-edit_packed'
export const ORDERS_MODIFY_ADDRESS = 'orders-modify_address'
export const ORDERS_UPLOAD_LABEL = 'orders-upload_label'
export const ORDERS_HOLD = 'orders-hold'
export const ORDERS_VIEW = 'orders-view'
export const ORDERS_BATCH = 'orders-batch'
export const ORDERS_QUICK_BATCH = 'orders-quick_batch'
export const ORDERS_DELETE = 'orders-delete'
export const ORDERS_RED_CLIP = 'orders-red_clip'
export const ORDER_FINISH_PACK = 'order_finish_pack'
export const PURCHASE_ORDER_CREATE = 'purchase_order-create'
export const PURCHASE_ORDER_EDIT = 'purchase_order-edit'
export const PURCHASE_ORDER_EXPORT_EXPECTED_DETAILS = 'purchase_order-export_expected_details'
export const PURCHASE_ORDER_VIEW_PRICE = 'purchase_order-view_price'
export const PURCHASE_ORDER_CHANGE_STATUS = 'purchase_order-change_status'
export const ZONE_CREATE = 'zone-create'
export const ZONE_DELETE = 'zone-delete'
export const ZONE_EDIT = 'zone-edit'
export const ZONE_REPLENISH = 'zone-replenish'
export const RETURN_CREATE = 'return-create'
export const RETURN_EDIT = 'return-edit'
export const RETURN_DELETE = 'return-delete'
export const RETURN_VIEW = 'return-view'
export const RETURN_REOPEN = 'return-reopen'
export const RECEIVING_CREATE = 'receiving-create'
export const RECEIVING_EDIT = 'receiving-edit'
export const RECEIVING_DETAILS = 'receiving-details'
export const RECEIVING_DELETE = 'receiving-delete'
export const RECEIVING_FINALIZED = 'receiving-finalized'
export const RECEIVING_REOPEN = 'receiving-reopen'
export const RECEIVING_PRINT_TAGS = 'receiving-print_tags'
export const RECEIVING_BILLABLE = 'receiving-billable'
export const RECEIVING_PENDING_APPROVE = 'receiving-pending_approve'
export const RECEIVING_PENDING_CLOSE = 'receiving-pending_close'
export const PERMISSIONS_CREATE = 'permissions-create'
export const PERMISSIONS_EDIT = 'permissions-edit'
export const PERMISSIONS_DELETE = 'permissions-delete'
export const ROLES_CREATE = 'roles-create'
export const ROLES_EDIT = 'roles-edit'
export const ROLES_DELETE = 'roles-delete'
export const USER_CREATE = 'user-create'
export const USER_EDIT = 'user-edit'
export const USER_DELETE = 'user-delete'
export const SYSTEM_CREATE = 'system-create'
export const SYSTEM_EDIT = 'system-edit'
export const SYSTEM_DELETE = 'system-delete'
export const WAREHOUSE_CREATE = 'warehouse-create'
export const SHIPPING_TRANSFER = 'shipping-transfer'
export const SHIPPING_TRACKING_DETAILS = 'shipping-tracking_details'
export const WAREHOUSE_EDIT = 'warehouse-edit'
export const WAREHOUSE_DELETE = 'warehouse-delete'
export const INTERNAL_SUPPORT_RED_CLIP_FORM = 'internal_support-red_clip_form'
export const INTERNAL_SUPPORT_RED_CLIP_MANAGEMENT = 'internal_support-red_clip_management'
export const INVENTORY_COUNTS_CREATE = 'inventory_counts-create'
export const INVENTORY_COUNTS_EDIT = 'inventory_counts-edit'
export const INVENTORY_COUNTS_DELETE = 'inventory_counts-delete'
export const INVENTORY_COUNTS_VIEW = 'inventory_counts-view'
export const SUPPORT_HOW_TO_GUIDES = 'support-how_to_guides'
export const SUPPORT_SUPPORT = 'support-support'
export const ISSUES_VIEW_ALL = 'issues-view_all'
export const ISSUES_CREATE = 'issues-create'
export const ISSUES_EDIT = 'issues-edit'
export const JOBS_PROXPERT = 'jobs-proxpert'
export const USER_DEVICES = 'user_devices'
export const PRINTERS_ALL_WAREHOUSES = 'printers_all_warehouses'
